<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/customers'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
    :defaultPayload="updateDefaultPayload"
  />
</template>

<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { mapGetters } from "vuex";
import { CustomerSubRegionService } from "../../../_services/api/settings/customers/customer-sub-region.service";
import { CustomerDeliveryAddressService } from "../../../_services/api/customers/customer-delivery-address.service";
import { SplitViewService } from "../../../_services/api/templates/split-view.services";
// import {
//   RegionTabs,
//   GetIndexByTabName,
// } from "../../../_models/tabdata/settings/region-tabs";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      validationSummary: [],
      setLoading: false,
      formModel: {
        IsDefault: "Y",
        IsDefaultData: false,
        SetDefault: true,
        Inactive: true,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      CustomerRegionCode: undefined,
      data: {
        title: "Sub Region",
        pageRoute: "/customer-sub-region",
        saveEndPoint: "CustomerSubRegion",
        updateEndPoint: "CustomerSubRegion",
        recordEndPoint: "CustomerSubRegion",
        // isDefaultEndPoint: "Save_DefaultCustomerSubRegion",
        exportFileName: "Customer Sub Region List",
        // selectedIndex: GetIndexByTabName("Sub Region"),
        // tabs: RegionTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CustomerSubRegion",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "customer-sub-region",
              mode: "review",
              idProperty: "RecordId",
              idMode: "Guid",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/customer-sub-region/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              // /////////
              screenField: "SubRegion",
              // dataField: "CustomerRegionCode",
              // label : "Sub Region",
              allowHiding: false,
              sortOrder: "asc",
              sortIndex: 0,
            },
            {
              dataField: "ChangedBy",
              label: "Changed By",
            },
            {
              screenField: "IsDefault",
              cellTemplate: "CheckBoxTemplate",
              makeDisabled: (data) => {
                return data.data.Inactive == "Y";
              },
              makeReadOnly: (data) => {
                return (
                  data.column.dataField == "IsDefault" &&
                  data.data.IsDefault == "Y"
                );
              },
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: "0",
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "IsDefault",
              listner: async (event, cellInfo, grid, updateIsDefault) => {
                this.onIsDefailtChange(event, cellInfo, grid, updateIsDefault);
              },
            },
          ],
        },
      },
    };
  },
  computed: {
    ...mapGetters({ updateIsDefaultCode: "ui/getUpdateIsDefaultCode" }),
    updateDefaultPayload() {
      return {
        Code: this.updateIsDefaultCode,
        CustomerRegionCode: this.CustomerRegionCode,
      };
    },
    setDefaultEdit() {
      return this.formModel["IsDefaultData"] || !this.formModel["Inactive"];
    },
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
                onValueChanged: (e) => {
                  this.onActiveValueChanged(e);
                },
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "CustomerRegionCode",
                //  label :{
                //  text : "Region"
                //  },
                required: true,
                allowUpdate: this.baseView.mode == "edit" ? false : true,
                screenField: "Region",
              },

              {
                dataField: "Code",

                label: {
                  text: "Sub Region",
                },

                required: true,
                // allowUpdate: this.baseView.mode == "edit" ? false : true,
                screenField: "Code",
              },

              {
                dataField: "SetDefault",
                editorOptions: {
                  readOnly: this.setDefaultEdit,
                },
                screenField: "IsDefault",
              },
            ],
          },
        ],
      };

      return form;
    },
  },
  methods: {
    async onIsDefailtChange(event, cellInfo, grid) {
      // updateIsDefault
      var items = grid.getDataSource().items();
      var getDefault,
        clickedDefault = undefined;
      if (items)
        items.forEach((element) => {
          if (
            element.Code == cellInfo.data.Code &&
            element.CustomerRegionCode == cellInfo.data.CustomerRegionCode
          )
            clickedDefault = element.Code;
          if (
            element.IsDefault == "Y" &&
            element.CustomerRegionCode == cellInfo.data.CustomerRegionCode
          )
            getDefault = element.Code;
        });

      if (!getDefault) this.setLoading = true;
      await CustomerSubRegionService.getDefaultByRegion(
        cellInfo.data.CustomerRegionCode
      )
        .then((res) => {
          if (res.data.value.length > 0) getDefault = res.data.value[0].Code;

          this.setLoading = false;
        })
        .catch((err) => {
          if (err) this.setLoading = false;
        });

      let confirmLeaving = await this.$confirm(
        `Do you want to change the default setting from ${getDefault} to ${clickedDefault} ?`,
        "Default Setting Change"
      );

      if (!confirmLeaving) {
        event.component.beginUpdate();
        event.component.option("value", false);
        event.component.endUpdate();
        this.CustomerRegionCode = undefined;
        return;
      } else {
        this.CustomerRegionCode = cellInfo.data.CustomerRegionCode;
        cellInfo.data.IsDefault = "Y";
        this.setLoading = true;
        this.unpdateIsDefault(cellInfo.data);
        // this.$store.dispatch("ui/setUpdateIsDefault", {
        //   update: true,
        //   code: cellInfo.data.Code,
        //   event: event,
        // });
      }
    },
    async onActiveValueChanged(e) {
      if (
        this.baseView.mode == "edit" &&
        e.value == false &&
        e.previousValue == true
      ) {
        this.setLoading = true;
        await CustomerDeliveryAddressService.getCustomRequest(
          `SubregionCode eq '${this.formModel["Code"]}'`
        )
          .then((res) => {
            this.setLoading = false;

            if (res.data.value.length > 0) {
              this.formModel.Inactive = true;

              e.component.beginUpdate();
              e.component.option("value", true);
              e.component.endUpdate();

              this.validationSummary = [];
              this.validationSummary.push({
                message: `${this.formModel["Code"]} is associated with Customer Delivery Address records. This may not be marked inactive until it is no longer associated with Customer Delivery Address records.`,
              });
              this.validationSummary.push({
                message: `Tip: To identify the associated Customer Delivery Address use the filters on the Customer Delivery Address list.`,
              });
            }
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });
      }
    },
    async unpdateIsDefault(data) {
      let payload = { ...data };
      await SplitViewService.updateItem(
        this.data.updateEndPoint,
        payload.RecordId,
        payload
      )
        .then((res) => {
          if (res) this.setLoading = false;
          this.$store.dispatch("ui/setUpdateGridOnDefault", true);
        })
        .catch((err) => {
          this.$logger.debug("Save item err ", err);
          this.setLoading = false;
          this.displayServerError(err, "Item Save Failed");
        });
    },
  },
};
</script>
